import React, { useEffect } from 'react';
import { useCurrencyStore, Currency, CURRENCY_SYMBOLS } from '../lib/currencyStore';

export default function CurrencySelector() {
  const { currency, setCurrency, updateExchangeRates, lastUpdated } = useCurrencyStore();

  // Update exchange rates when component mounts and then hourly
  useEffect(() => {
    // First check if rates need to be updated (based on last update time)
    const checkAndUpdateRates = async () => {
      try {
        await updateExchangeRates();
      } catch (error) {
        console.error('Failed to update exchange rates:', error);
      }
    };
    
    // Check rates on component mount
    checkAndUpdateRates();

    // Set up hourly interval to check and update rates
    const interval = setInterval(checkAndUpdateRates, 60 * 60 * 1000); // Every hour
    return () => clearInterval(interval);
  }, [updateExchangeRates]);

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        {(Object.keys(CURRENCY_SYMBOLS) as Currency[]).map((curr) => (
          <button
            key={curr}
            onClick={() => setCurrency(curr)}
            className={`px-3 py-1.5 rounded-lg border transition-colors ${
              currency === curr
                ? 'bg-white/10 border-white/25 text-white'
                : 'border-white/10 text-white/60 hover:text-white hover:border-white/25'
            }`}
          >
            {curr} {CURRENCY_SYMBOLS[curr]}
          </button>
        ))}
      </div>
      {lastUpdated && (
        <p className="text-xs text-white/40">
          Rates updated: {new Date(lastUpdated).toLocaleTimeString()} (updates hourly)
        </p>
      )}
    </div>
  );
}